import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import enNav from './locales/en/nav.json';
import enSales from './locales/en/sales.json';
import enClients from './locales/en/clients.json';
import enProposals from './locales/en/proposals.json';
import enPortal from './locales/en/portal.json';
import enProfile from './locales/en/profile.json';

import ruCommon from './locales/ru/common.json';
import ruNav from './locales/ru/nav.json';
import ruSales from './locales/ru/sales.json';
import ruClients from './locales/ru/clients.json';
import ruProposals from './locales/ru/proposals.json';
import ruPortal from './locales/ru/portal.json';
import ruProfile from './locales/ru/profile.json';

const resources = {
  en: {
    common: enCommon,
    nav: enNav,
    sales: enSales,
    clients: enClients,
    proposals: enProposals,
    portal: enPortal,
    profile: enProfile
  },
  ru: {
    common: ruCommon,
    nav: ruNav,
    sales: ruSales,
    clients: ruClients,
    proposals: ruProposals,
    portal: ruPortal,
    profile: ruProfile
  }
};

export function normalizeLanguage(lang) {
  const l = String(lang || 'en').trim().toLowerCase();
  return l === 'ru' ? 'ru' : 'en';
}

export async function applyLanguage(lang) {
  const next = normalizeLanguage(lang);
  if (i18n.language !== next) {
    await i18n.changeLanguage(next);
  }
  if (typeof window !== 'undefined' && window.SFTNavMenu?.setLanguage) {
    window.SFTNavMenu.setLanguage(next);
  }
  try {
    document.documentElement.lang = next;
  } catch (_) {}
  return next;
}

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'nav', 'sales', 'clients', 'proposals', 'portal', 'profile'],
    interpolation: { escapeValue: false },
    returnNull: false
  });
}

export default i18n;
